import { useAlert } from 'contexts/alert'
import { useAuth } from 'contexts/auth'
import api from 'services/api'
import { acaoParaErroDeSessao, esquecerOrganizacaoGuardada, ROTA_DE_ESCOLHA } from './sessao-erro'

// why: o backend recusa a sessão de usuário bloqueado ou desabilitado com 401 e
// `code: 'ACESSO_SUSPENSO'` (F0b). Só esse código desloga: o ensureAdmin também
// devolve 401 e não pode derrubar a sessão de quem abriu uma tela sem permissão.
const ACESSO_SUSPENSO_CODIGO = 'ACESSO_SUSPENSO'

const MENSAGENS_500_DE_TOKEN = [
  'invalid signature',
  'jwt expired',
  'invalid token',
  'jwt malformed',
  'jwt signature is required',
]

const useAxiosInterceptor = () => {
  const { signOut } = useAuth()
  const { openAlert } = useAlert()

  api.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status
      const data = error?.response?.data?.data

      if (status === 401 && data?.code === ACESSO_SUSPENSO_CODIGO) {
        signOut()
        // hazard: o AlertProvider guarda um alerta só e vence a última escrita.
        // O catch de quem chamou a API (ex.: "Erro ao deletar organização") roda
        // depois deste reject; o setTimeout põe a frase por último.
        setTimeout(() => openAlert(data.message, 'error'), 0)
      }

      // why: sessão honesta (F1). Só chega quando o modo manda aplicar: a sessão
      // de organização a que a pessoa já não tem acesso sai, com a frase; a sessão
      // sem organização escolhida vai à escolha.
      const acao = acaoParaErroDeSessao(error)
      if (acao === 'SAIR') {
        signOut()
        setTimeout(() => openAlert(data.message, 'error'), 0)
      }
      if (acao === 'ESCOLHER_ORGANIZACAO' && window.location.pathname !== ROTA_DE_ESCOLHA) {
        esquecerOrganizacaoGuardada(window.localStorage)
        window.location.assign(ROTA_DE_ESCOLHA)
      }

      if (status === 400 && data?.message === 'Invalid token!') {
        signOut()
      }

      if (status === 500 && MENSAGENS_500_DE_TOKEN.includes(data?.message)) {
        signOut()
      }

      return Promise.reject(error)
    }
  )
}

export default useAxiosInterceptor
